import React from "react";
import Image from "next/image";
import { getSafeImageUrl } from "@/utils/images";
import Link from "next/link";

interface StoreCardProps {
  name: string;
  logo: string;
  offers: number;
  coupons?: number;
  slug: string;
}

const StoreCard: React.FC<StoreCardProps> = ({ name, logo, offers, coupons, slug }) => {
  const [imgError, setImgError] = React.useState(false);
  return (
    <Link 
      href={`/store/${slug}`} 
      className="block h-full w-full" 
      aria-label={`View deals for ${name}`}
    >
      <div 
        className="flex flex-col items-center justify-between bg-white rounded-lg shadow lg:p-4 p-2 h-full 
                   border border-gray-200 
                   hover:shadow-xl hover:scale-[98%] hover:border-primary-400 
                   focus-within:shadow-xl focus-within:border-primary-500 
                   animate-fadein cursor-pointer transition"
      >
        <Image
          src={imgError ? '/assets/OfferCodeFlight.jpg' : getSafeImageUrl(logo)}
          alt={name}
          width={56}
          height={56}
          className="w-1/2 max-w-[56px] h-[50px] md:max-w-[112px] md:h-20 object-contain mb-1 md:mb-2"
          onError={() => setImgError(true)}
        />
        <div className="font-medium text-sm text-gray-800 text-center truncate w-full px-1 mt-auto">
          {name}
        </div>
        <div className="flex items-center justify-center gap-1 text-[10px] lg:text-[11px] sm:text-xs text-primary-600 whitespace-nowrap mt-1">
          {typeof coupons === 'number' ? (
            <>
              <span>{coupons} Coupons</span>{' '}
              <span className="text-gray-400">|</span>{' '}
              <span>{offers} Offers</span>
            </>
          ) : (
            <span>{offers} Offers</span>
          )}
        </div>
      </div>
    </Link>
  );
};


export default StoreCard;